<template>
  <div class="table-form table-responsive">
    <table class="table">
      <thead>
      <tr>
        <th scope="col">Tutar</th>
        <th scope="col">Detay</th>
        <th scope="col">Tarih</th>
        <th scope="col">Type</th>
        <th scope="col">Değiştir</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="agencyPayment in agencyPayments" :key="agencyPayment.id">
        <template v-if="!agencyPayment.deleted">
          <th scope="row">{{ agencyPayment.amount }} €</th>
          <!--        <th v-else="edit" scope="row">-->
          <!--          <base-edit-input v-model="agencyPayment.amount"/>-->
          <!--        </th>-->

          <th>{{ agencyPayment.reason }}</th>
          <!--        <th v-else>-->
          <!--          <base-edit-input v-model="agencyPayment.reason"/>-->
          <!--        </th>-->

          <th>{{ agencyPayment.createDate | ddMMyyyyHHmm}} </th>

          <th>{{ agencyPayment.type}} </th>

          <th>
            <div class="table-content">
              <button @click="editAgencyPayment(agencyPayment)" class="theme-btn theme-btn-small" data-toggle="tooltip" data-placement="top" title="" data-original-title="Edit">
                <i class="la la-edit"></i>
              </button>
              <button @click="deleteAgencyPayment(agencyPayment)" class="theme-btn theme-btn-small" data-toggle="tooltip" data-placement="top" title="" data-original-title="Edit">
                <i class="la la-remove"></i>
              </button>
            </div>
          </th>
        </template>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import BaseEditInput from "../base/BaseEditInput";
export default {
  name: "AgencyPaymentsList",
  components: {BaseEditInput},
  computed:{
    agencyPayments:{
      get(){
        return this.$store.getters.getAgencyPayments;
      }
    }
  },
  methods:{
    editAgencyPayment(agencyPayment){
      this.$store.commit("setSelectedAgencyPayment", agencyPayment);
      this.$store.commit("setUpdateProcess",true);
      $("#agencyPaymentListModal").modal("hide");
      $("#createAgencyPaymentModal").modal("show");

    },

    deleteAgencyPayment(agencyPayment){
      this.$store.dispatch("deleteAgencyPayment", {id:agencyPayment.id});
    },

  }
}
</script>

<style scoped>
.table-form thead th {
  background-color: white;
  color: #1976d2;
}

.theme-btn{
  color: white!important;
}
</style>